import { Transaction } from 'interfaces/moneyflow'
import { FC } from 'react'

type TransactionNameProps = {
  transaction: Transaction
}
export const TransactionName: FC<TransactionNameProps> = (props) => {
  const { transaction } = props

  if (transaction.account_source_type === 'railsbank') {
    return (
      <>
        Status Money
      </>
    )
  }

  return (
    <>
      { transaction.account.name }
    </>
  )
}
